import axios from "./axios";

const uploadFile = (formData) => {
    return axios.post( '/file/upload',
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
        .then(response => response.data);
}

const getFile = id => {
    return axios.get(`/file/show/${id}`)
        .then(response => response.data)
}

const getApplicantApplicationFile = (fileId, applicationId) => {
    return axios.get(`/document/file/show/${fileId}/${applicationId}`)
        .then(response => response.data)
}

const getEmployeeApplicationFile = (fileId, applicationId) => {
    return axios.get(`/docflow/file/show/${fileId}/${applicationId}`, {responseType: 'blob'})
        .then(response => response.data)
}

export default {
    uploadFile,
    getFile,
    getApplicantApplicationFile,
    getEmployeeApplicationFile
}
